import { UI_FONT_FAMILY } from "./fonts";
import { TEXT_LINE_HEIGHT } from "./geometry";

// วันที่วันนี้ dd/mm/yyyy (era = "be" พ.ศ. | "ce" ค.ศ.) ใช้ร่วมกันในตัวแก้ PDF และตัวแก้ภาพ
export const formatToday = (era) => {
  const now = new Date();
  const dd = String(now.getDate()).padStart(2, "0");
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const yyyy = now.getFullYear() + (era === "be" ? 543 : 0);
  return `${dd}/${mm}/${yyyy}`;
};

// alert() ของระบบไม่แสดงถ้ามี SweetAlert เดิมยังปิดไม่เสร็จ (กันซ้อน) -> รอให้ตัวเดิมหายก่อนค่อยแจ้งผลต่อ
export const waitForSwalClose = async (timeout = 1500) => {
  const start = Date.now();
  while (document.querySelector(".swal2-container") && Date.now() - start < timeout) {
    await new Promise((resolve) => setTimeout(resolve, 50));
  }
};

export const fontString = (size, bold) => `${bold ? 700 : 400} ${size}px "${UI_FONT_FAMILY}", Sarabun, Tahoma, sans-serif`;

// ขนาดกล่องข้อความ (หน่วยเดียวกับ o.size) ใช้ย้าย/วางข้อความและกันล้นขอบ
let measureCtx = null;
export const textBox = (o) => {
  if (!measureCtx) measureCtx = document.createElement("canvas").getContext("2d");
  measureCtx.font = fontString(o.size, o.bold);
  const lines = String(o.text || "").split("\n");
  const w = Math.max(o.size, ...lines.map((l) => measureCtx.measureText(l).width));
  return { w, h: lines.length * o.size * TEXT_LINE_HEIGHT };
};
